import React, { Component } from 'react';

class PrintMessage extends Component {
    render() {
        return (
            <div id="print-warning" hidden>
                <p>Please choose something to print</p>
            </div>
        );
    }
}

export default PrintMessage;